import {
  get,
  set,
} from 'idb-keyval';

const setCourse = async function(o) {
  let courses = await get('courses');

  if (courses === undefined) {
    courses = {
      list: [],
    };
  }

  if (courses.list.length > 3) {
    // keep the list short
    courses.list = courses.list.slice(-3);
  }

  courses.list.push(o);
  set('courses', courses);
};

const courseTemplate = function(o) {
  return `
    <div class="nav-link-personal--content">
    <h3 class="text-white display-5">Recent Activity</h3>

      <span class="badge badge-light mb-3">
        ${ o.subjectArea }
      </span>

      <p class="cms-plugin cms-plugin-327432">
        <a href="${ o.url }">
        <strong> ${ o.title }</strong></a>
      </p>

      <dl class="d-none d-sm-block">
        <dt>Qualification:</dt>
        <dd> ${ o.qualification } </dd>
        <dt>Location:</dt>
        <dd> ${ o.locations } </dd>
      </dl>
    </div>`;
};

const populateBlock = async function(
    selector = '.nav-link-personal') {
  const els = document.querySelectorAll(selector);

  const courses = await get('courses');

  // if we have courses then show a course
  if (courses) {
    const course = courses.list.slice(-1)[0];

    els.forEach(function(el) {
      el.innerHTML = courseTemplate(course);
      // el.insertAdjacentHTML('beforeend', courseTemplate(course));
    });
  }
};

const personalisation = {
  setCourse,
  populateBlock,
};

export default personalisation;
